<template>
  <div class="py-2 cursor-pointer" @click="$emit('view-all-click')">
    <etg-button class="mx-auto" type="primary-text" size="small">
      {{ $t('general.view_all') }}
    </etg-button>
  </div>
</template>

<script lang="ts" setup>
interface Emits {
  (event: 'view-all-click'): void
}

defineEmits<Emits>()
</script>
